import { PERMISSION_CHECKS_ACTIONS_NAME, PERMISSION_CHECKS_GETTERS_NAME } from '@/common/store/permissionChecks/name';

import store from '@/store';

const applyVisibility = (el, permissionId) => {
  el.hidden = store.getters[PERMISSION_CHECKS_GETTERS_NAME.getIsHidden](permissionId);
};

const unwatchPermission = (el) => {
  if (el._permissionUnwatch) {
    el._permissionUnwatch();
    delete el._permissionUnwatch;
  }
};

const setupPermission = async (el, binding) => {
  if (!binding.value) {
    unwatchPermission(el);
    el.hidden = false;
    return;
  }

  const permissionId = Number.parseInt(binding.value, 10);

  if (Number.isNaN(permissionId)) {
    return;
  }

  if (el._permissionId !== permissionId) {
    unwatchPermission(el);
    el._permissionId = permissionId;
    el._permissionUnwatch = store.watch(
      (state) => state.permissionChecks.checks[permissionId],
      () => applyVisibility(el, permissionId),
    );
  }

  applyVisibility(el, permissionId);
  await store.dispatch(PERMISSION_CHECKS_ACTIONS_NAME.ensurePermissionChecked, permissionId);
};

export const permission = {
  mounted: async (el, binding) => {
    await setupPermission(el, binding);
  },
  updated: async (el, binding) => {
    await setupPermission(el, binding);
  },
  unmounted: (el) => {
    unwatchPermission(el);
    delete el._permissionId;
  },
};
